import { AutoSelectCircleContext } from '@rhg/providers/auto-select-circle';
import { useContext } from 'react';

export function useAutoSelectCircleState() {
    return useContext(AutoSelectCircleContext);
}
